module.exports = __webpack_public_path__ + "img/chevrons-down.ee5498b4.svg";